import {
  Box,
  Breadcrumbs,
  Typography,
  Tooltip,
  IconButton,
  Menu,
} from "@mui/material";
import usePage from "hooks/usePage";
import useFetch from "hooks/useFetch";
import { useState } from "react";
import ShareProjectMenuItem from "./ShareProjectMenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export default function ProjectBreadcrumb() {
  const { projectId } = usePage();
  const [anchorEl, setAnchorEl] = useState(null);

  const menuOpen = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const { data: projectResponse } = useFetch(`/project`);
  const project = projectResponse?.projects?.find(
    (p) => p.id === Number(projectId)
  );
  const projectName = project?.name || "-";
  const { data: customerResponse } = useFetch(
    `/customer/${project?.customer_id}`,
    {},
    !!project?.customer_id
  );
  const customerName = customerResponse?.name || "-";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: 2,
      }}
    >
      <Breadcrumbs sx={{ display: "flex" }}>
        <Typography variant="h5">{customerName}</Typography>
        <Typography variant="h5">
          {projectName + " (" + projectId + ")"}
        </Typography>
      </Breadcrumbs>

      <Tooltip title="Project settings">
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={menuOpen ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={menuOpen ? "true" : undefined}
        >
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="project-menu"
        open={menuOpen}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <ShareProjectMenuItem project={project} onClick={handleClose} />
      </Menu>
    </Box>
  );
}
